import { render, staticRenderFns } from "./BrandList.vue?vue&type=template&id=2f52d33d&scoped=true&"
import script from "./BrandList.vue?vue&type=script&lang=js&"
export * from "./BrandList.vue?vue&type=script&lang=js&"
import style0 from "./BrandList.vue?vue&type=style&index=0&id=2f52d33d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f52d33d",
  null
  
)

export default component.exports